enum ApprovalRequestStatus {
  Approved = 1,
  Pending = 2,
}

export default ApprovalRequestStatus;
